import './App.css';
import About from './components/About';
import Contact from './components/Contact';
import HomePage from './components/HomePage';
import Navbar from './components/Navbar';
import Portfolio from './components/Portfolio';

function App() {
  return (
    <div className="App">
      <Navbar/>
      <HomePage/>
      <About/>
      <Portfolio/>
      <Contact/>
    </div>
  );
}

export default App;
